import React, { createContext, useCallback, useContext, useState } from "react";
import WhatsAppModal from "../components/WhatsAppFlotante/WhatsAppModal";
import useFirestoreUpdate from "./useFirestoreData";
import { getUtmParams, getCurrentUrlWithUtmDefaults, openWhatsAppConsulta } from "./whatsappConfig";
import { sendToTecnom } from "./tecnomApi";

const WhatsAppConsultaContext = createContext(null);

export const useWhatsAppConsulta = () => {
  const ctx = useContext(WhatsAppConsultaContext);
  if (!ctx) {
    throw new Error("useWhatsAppConsulta debe usarse dentro de WhatsAppConsultaProvider");
  }
  return ctx;
};

export const WhatsAppConsultaProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const openConsultaForm = useCallback(() => {
    setOpen(true);
  }, []);

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      const utms = getUtmParams();
      await updateData({
        ...values,
        ...utms,
        url: getCurrentUrlWithUtmDefaults(),
      });
      setOpen(false);

      try {
        await sendToTecnom({
          brand: "HYUNDAI",
          name: values.nombre,
          email: values.email,
          phone: values.celular,
          comments: "Consulta desde modal de WhatsApp",
          tipoPlan: "venta directa",
          ...utms,
          campaign: "HYUNDAI_WHATSAPP_MODAL",
        });
      } catch (tecnomError) {
        console.error("Error al enviar a Tecnóm:", tecnomError);
      }

      openWhatsAppConsulta();
    } catch (error) {
      console.error("Modal WhatsApp — error al guardar en Firestore:", error);
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <WhatsAppConsultaContext.Provider value={{ openConsultaForm, loading }}>
      {children}
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
    </WhatsAppConsultaContext.Provider>
  );
};
